// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"e2fb3609","488":"5bbec19d"}[chunkId] + ".chunk.js";
};